<template>
  <BaseModal
    ref="BaseModal"
    confirmText="确定"
    resetText="清空"
    @confirm="confirm"
    @reset="reset"
    @close="close"
  >
    <div class="FilterFieldModal">
      <div class="input" v-for="(item, i) in form" :key="i">
        <label>{{ item.label }}</label>
        <el-radio-group v-model="item.value" v-if="item.type === 'checkbox'">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
        <el-input
          v-else
          v-model.trim="item.value"
          placeholder="请输入"
          sizi="mini"
        ></el-input>
      </div>
      <!-- <div class="btns">
        <el-button type="primary" size="mini" @click="confirm">确定</el-button>
        <el-button type="primary" size="mini" @click="clean">清空</el-button>
      </div> -->
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '../BaseModal/index.vue'

export default {
  name: 'FilterFieldModal',
  components: { BaseModal },
  data() {
    return {
      options: {},
      form: []
    }
  },
  methods: {
    // 显示弹窗
    show(options = {}) {
      this.options = { ...options }
      this.$refs.BaseModal.show({
        title: '查询',
        confirmText: '确定',
        resetText: '清空',
        width: '350px'
      })
      const map = {}
      this.form.forEach(e => (map[e.key] = e.value))
      this.form = options.columns
        .filter(e => e.field !== 'operation')
        .map(e => ({
          label: e.title,
          key: e.field,
          value: map[e.field],
          type: e.cellType
        }))
    },
    confirm() {
      // 调用外部传入的confirm回调函数
      this.options.confirm?.(this.form)

      // 关闭弹窗
      // this.$refs.BaseModal.close()
    },
    reset() {
      this.form.forEach(e => {
        e.value = ''
      })
    },
    close() {
      // 调用外部传入的cancel回调函数
      this.options.cancel?.()
    }
  }
}
</script>

<style scoped lang="less">
.FilterFieldModal {
  .input {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 8px;

    ::v-deep .el-input {
      flex: 1;
    }

    > label {
      min-width: 120px;
      text-align: right;
      padding-right: 12px;
    }

    ::v-deep .el-input__inner {
      padding: 0 4px;
    }
  }

  .btns {
    text-align: right;
    margin-top: 12px;
  }
}
</style>
